import { useState, useEffect } from 'react';
import axios from 'axios';
import config from './../../config';
import { useTranslation } from 'react-i18next';

export default function useFooterData() {
  const { t, i18n } = useTranslation();
  const [conditions, setConditions] = useState([]);
  const [footerData, setFooterData] = useState([]);

  // Récupérer toutes les pages sauf celle avec le titre "## a propos"
  const getAllMenu = async () => {
    try {
      const response = await axios.get(`${config.SITE_API_URL}/page`,
        { headers: { 'x-api-key': config.SITE_API_KEY } }
      );
      const filteredData = Array.isArray(response?.data)
        ? response.data.filter((page) => (page.title.fr !== 'À propos')&&(page.title.ar !== 'حول'))
        : [];
      setConditions(filteredData);
    } catch (error) {
      console.error(t('errors.fetch_pages_error'), error.message);
      setConditions([]);
    }
  };

  // Charger les données au montage du composant
  useEffect(() => {
    getAllMenu();
  }, []);

  // Mettre à jour les données du footer lorsque les conditions ou la langue changent
  useEffect(() => {
    setFooterData([
      {
        title: t('menu'),
        submenu: [
          { title: t('home'), link: '/' },
          { title: t('about'), link: '/apropos' },
          { title: t('courses'), link: '/course' },
          { title: t('subscription_pack'), link: '/subscription' },
          { title: t('contact_footer'), link: '/contact' },
        ],
      },
      {
        title: t('terms_and_conditions'),
        submenu: conditions.map((cond) => ({
          title: cond?.title?.[i18n.language] || cond?.title?.fr || t('condition'),
          link: `/condition/${cond?._id}`,
        })),
      },
    ]);
  }, [conditions, i18n.language, t]);

  return footerData;
}